import React, {
  FC, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { Dialog, IconButton, LinearProgress } from '@mui/material';
import { Close } from '@mui/icons-material';
import { DialogHeader, DialogHeaderTitle } from '../Shared/styles/dialog';
import { IDispatchProps, IProps, IStateProps } from './interfaces';
import { IAppState } from '../../state/reducers';
import { toggleTimeoutTeams, clearTimeoutTeams } from '../../state/timeoutTeams';
import {
  TeamContainer, StyledAvatar, TeamListContainer, DialogContentContainer,
} from './styles';
import { ProgressContainer } from '../Shared/JobList/styles';
import { Warning } from '../Shared';

const TimeoutTeamsDialog: FC<IProps> = (props: IProps) => {
  const {
    isLoading, onClose, teams, isOpen,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogHeader
        data-auto="TimeoutTeams"
      >
        <DialogHeaderTitle style={{ marginLeft: '12px' }}>
          Non Compliant Teams
        </DialogHeaderTitle>
        <IconButton data-auto="CloseTimeoutTeams" onClick={onClose} size="large">
          <Close />
        </IconButton>
      </DialogHeader>
      <ProgressContainer>
        {isLoading && <LinearProgress />}
      </ProgressContainer>
      <DialogContentContainer>
        {teams && (
          <>
            <Warning
              isWarning={!teams.length}
              message="No Teams Teams in Restricted Access"
            />
            {teams.map((timeoutTeam) => (
              <TeamListContainer>
                <TeamContainer>
                  <StyledAvatar
                    alt={timeoutTeam.TeamName}
                    src={timeoutTeam.TeamImage}
                    data-auto="TimeoutTeamListItem"
                    data-teamcode={timeoutTeam.TeamCode}
                  />
                  {timeoutTeam.TeamName} {timeoutTeam.TeamCode ? `(${timeoutTeam.TeamCode})` : null}
                </TeamContainer>
              </TeamListContainer>
            ))}
          </>
        )}
      </DialogContentContainer>
    </Dialog>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isLoading: state.timeoutTeams.isLoading,
  isOpen: state.timeoutTeams.isOpen,
  teams: state.timeoutTeams.teams,
});

const mapDispatchToProps: IDispatchProps = {
  onGetTimeoutTeams: toggleTimeoutTeams,
  onClose: clearTimeoutTeams,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimeoutTeamsDialog);
